module.exports = __webpack_public_path__ + "static/img/ak47.da13baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/ak47.png
// module id = B+8Y
// module chunks = 1